export type ContractDrawerAction = 'show' | 'edit' | 'accept' | 'view'

export function buildContractDrawerUrl(
  root: string,
  action: ContractDrawerAction | string,
  hireLocalId: string,
  contractLocalId?: string,
): string {
  switch (action) {
    case 'accept':
      return `${root}/hires/${hireLocalId}/accept`
    case 'edit':
      return `${root}/hires/${hireLocalId}/edit`
    case 'view':
      return `${root}/hires/${hireLocalId}/contracts/${contractLocalId}`
    default:
      return `${root}/hires/${hireLocalId}`
  }
}
